import ReactPhoneInput from "react-phone-number-input/input";
import { cn } from "../../../helpers";
import styles from "./PhoneInput.module.scss";

export interface PhoneInputProps {
    className?: string;
    placeholder: string;
    onChange: (value: string | undefined) => void;
    label?: string;
    value?: string;
    isRequired?: boolean;
}

export default function PhoneInput({
    className,
    placeholder,
    onChange,
    label,
    value,
    isRequired,
}: PhoneInputProps) {
    return (
        <div className={cn({ [styles.phoneInputWrapper]: label })}>
            {label && (
                <div className={styles.label}>
                    {label}
                    {isRequired && (
                        <span className={styles.required} aria-label="required">
                            *
                        </span>
                    )}
                </div>
            )}
            <ReactPhoneInput
                className={cn(styles.phoneInput, className)}
                placeholder={placeholder}
                country="US"
                onChange={onChange}
                value={value}
            />
        </div>
    );
}
